// linking.config.ts
import { LinkingOptions } from "@react-navigation/native";
import { Platform } from "react-native";
import { RootStackParamList } from "../types/navigation";
import { config } from "../config";
import { secureStoreService } from "../components/shared/services/secure-store.service";

// Helper function to get hostname (only for web)
const getHostname = (): string => {
  console.log("getHostname", window?.location?.hostname);
  if (Platform.OS === "web") {
    return window.location.hostname;
  }
  return "";
};

export const linkingConfig: LinkingOptions<RootStackParamList> = {
  prefixes: config.pwa.prefixes,
  config: {
    screens: {
      Login: {
        path: "login",
        exact: true,
      },
      HomeScreen: "home",
      RestaurantMenu: "restaurant",
      CartScreen: "cart",
      UserAddress: "address",
      Help: "help",
    },
  },
};

// Helper function to fetch restaurant ID (implement this)
//TODO: actual implementation pending
//Get from cache in local if not then API.
export async function fetchRestaurantIdByName(name: string): Promise<string> {
  console.log("fetchRestaurantIdByName called name:", name);
  // Call your AWS Lambda to get restaurant ID from name
  return "1d97dd91-aa40-4cfa-b968-420ec61d2dbc";
}
